module.exports = __webpack_public_path__ + "img/nullData.88584cc0.png";